/* eslint-disable */
import request from '@/utils/request';
// import store from '../store';
import { feedbackHost } from './index';

const BASE_URL = '/api';
const as_url = 'http://test-mphys.classba.cn/api';

const feedbackUrl = 'http://chenks-hci.classba.cn';

const checkVideoUrl = '//check-video.classba.cn';
const login = (data) => request({
  url: `${BASE_URL}/student/loginIn`,
  method: 'post',
  data,
});

const nextStep = (data) => request({
  url: `${BASE_URL}/mphy/flow/go`,
  method: 'post',
  data,
});

const submitAnswer = (data) => request({
  url: `${BASE_URL}/mphy/flow/submitQuestion`,
  method: 'post',
  data,
});

// const submitWelcome = (data) => request({
//   url: `${BASE_URL}/mphy/event/submitInitStatus`,
//   method: 'post',
//   data: {
//     topicId: store.state.topic.topicId,
//     initStatus: data,
//   },
// });

const submitError = (data) => request({
  url: `${BASE_URL}/mphy/event/submitError`,
  method: 'post',
  data,
});

const getReportData = (data) => request({
  url: `${BASE_URL}/mphy/report/getModuleReport`,
  method: 'post',
  data,
});

const getReportCenter = (data) => request({
  url: `${BASE_URL}/mphy/flow/reportCenter`,
  method: 'post',
  data,
});

const getAllQuestion = (data) => request({
  url: `${BASE_URL}/mphy/report/getModuleQuestionList`,
  method: 'post',
  data,
});
const getAmtAllQuestion = (data) => request({
  url: '/amtapi/api/homework/report/getModuleQuestionList',
  method: 'post',
  data,
});
const getMtAllQuestion = (data) => request({
  url: '/mtapi/api/report/getQuestionList',
  method: 'post',
  data,
});
const submitInitStatus = (data) => request({
  url: `${BASE_URL}/mphy/event/submitInitStatus`,
  method: 'post',
  data,
});

const getTransitionReport = (data) => request({
  url: `${BASE_URL}/mphy/report/getTransitionReport`,
  method: 'post',
  data,
});

const submitGuideEnmu = (data) => request({
  url: `${BASE_URL}/mphy/event/submitGuideEnmu`,
  method: 'post',
  data,
});

const checkVideo = (url) => request({
  baseURL: checkVideoUrl,
  url: `video_m3u8.php?u=${encodeURIComponent(url)}`,
});

const getCompare = (data) => request({
  baseURL: `${BASE_URL}/mphy/report/getCompare`,
  method: 'post',
  data,
});

const checkCompareApi = (data) => request({
  baseURL: `${BASE_URL}/mphy/report/checkCompare`,
  method: 'post',
  data,
});
const getErrorCodeList = (data) => request({
  url: `${BASE_URL}/mphy/report/getErrorCodeList`,
  method: 'post',
  data,
});

const getTagCodeList = (data) => request({
  url: `${BASE_URL}/mphy/report/getTagCodeList`,
  method: 'post',
  data,
});

const applyLessonTime = (data) => request({
  url: `${BASE_URL}/mphy/flow/applyStudyTime`,
  method: 'post',
  data,
});

const feedBack = (data) => request({
  url: `${feedbackHost}/api/feedback`,
  method: 'post',
  data,
});

const getQuestionByTagCode = (data) => request({
  url: `${feedbackHost}/api/getQuestionByTagCode`,
  method: 'post',
  data,
});

const getErrorReason = (data) => request({
  url: `${feedbackHost}/api/getErrorReason`,
  method: 'post',
  data,
});

const getFeedbackDetail = (data) => request({
  url: `${feedbackHost}/api/getFeedbackDetail`,
  method: 'post',
  data,
});

const getGraspTagCode = (data) => request({
  url: `${feedbackHost}/api/getGraspTagCode`,
  method: 'post',
  data,
});

const updateUserGuideStatus = (data) => request({
  url: 'api/mphy/flow/updateUserGuideStatus',
  method: 'post',
  data,
});

const getQuestionAnalyze = (data) => request({
  url: 'api/mphy/flow/getQuestionAnalyze',
  method: 'post',
  data,
});

const getAddCrystal = (data) => request({
  url: `${feedbackHost}/game/embrave/notify`,
  // url: 'http://game-api.test.classba.cn/embrave/notify',
  method: 'post',
  data,
});

const getUserTag = (data) => request({
  url: `${feedbackHost}/api/getUserTag`,
  method: 'post',
  data,
});

const getNextStudyInfo = (data) => request({
  url: `${feedbackHost}/api/getNextStudyInfo`,
  method: 'post',
  data, // token string 学习系统中产生的token
});

const getStudyUrl = (data) => request({
  url: `${feedbackHost}/api/getStudyUrl`,
  method: 'post',
  data, // token string 学习系统中产生的token
});


export {
  login,
  nextStep,
  submitAnswer,
  getReportData,
  getReportCenter,
  // submitWelcome,
  getAllQuestion,
  getAmtAllQuestion,
  getMtAllQuestion,
  submitError,
  submitInitStatus,
  getTransitionReport,
  submitGuideEnmu,
  checkVideo,
  checkCompareApi,
  getCompare,
  applyLessonTime,
  getTagCodeList,
  getErrorCodeList,
  feedBack,
  getQuestionByTagCode,
  getErrorReason,
  getFeedbackDetail,
  getGraspTagCode,
  updateUserGuideStatus,
  getQuestionAnalyze,
  getAddCrystal,
  getUserTag,
  getNextStudyInfo,
  getStudyUrl,
};
